import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  songsBlockHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    userSelect: 'none',
    gap: '6px',

    // FOR GTM TRIGGER
    '& > .viboButton .viboIcon': {
      pointerEvents: 'none',
    },

    '@media screen and (min-width: 1441px)': {
      gap: '8px',
    },
  },

  searchOption: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: 400,

    //for gtm tracking propper target
    '& > *': {
      pointerEvents: 'none',
    },
  },

  spotifyIcon: {
    color: 'var(--clr-mountainMeadow)',
  },
}));

export default useStyles;
